import teachers from "./teachers.svg";
import quality from "./quality.svg";
import money from "./money.svg";
import AOS from "aos"
import 'aos/dist/aos.css';
import { useEffect } from "react";


const Cards = () => {
    useEffect(() => {
        AOS.init();
      }, [])
  return (
    <>
      <div className="container my-5">
        <h3 className="text-dark text-center my-3 rounded p-2" style={{backgroundColor: "#f4a261"}}>We are better known for </h3>
        <div className="row mt-5">
          {/* Card 1 */}
          <div className="col-12 col-md-4 mb-4">
            <div
              className="card"
              style={{ width: "100%", backgroundColor: "#e9edc9" }}
              data-aos="zoom-in-right"
            >
              <img
                className="card-img-top w-100 mx-auto d-block"
                src={teachers}
                alt="..."
                style={{ maxHeight: "200px", objectFit: "contain" }}
            draggable="false"

              />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Quality Education</h5>
                <hr />
                <p className="card-text flex-grow-1">
                  We believe that quality education should be accessible to
                  everyone. That's why we are committed to providing top-notch
                  education at minimal charges, ensuring that financial
                  constraints do not hinder a student's potential.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-12 col-md-4 mb-4">
            <div
              className="card"
              style={{ width: "100%", backgroundColor: "#e9edc9" }}
              data-aos="zoom-out"
            >
              <img
                className="card-img-top w-100 mx-auto d-block"
                src={quality}
                alt="..."
                style={{ maxHeight: "200px", objectFit: "contain" }}
            draggable="false"

              />
              <div className="card-body d-flex flex-column"
              >
                <h5 className="card-title">Best Faculty</h5>
                <hr />
                <p className="card-text flex-grow-1"
                >
                  We are committed to providing the best faculty and
                  infrastructure to ensure a conducive learning environment. Our
                  experienced and dedicated teachers bring years of expertise
                  and a passion for teaching, inspiring students to achieve
                  their full potential.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-12 col-md-4 mb-4">
            <div
              className="card"
              style={{ width: "100%", backgroundColor: "#e9edc9" }}
              data-aos="zoom-in-left"

            >
              <img
                className="card-img-top w-100 mx-auto d-block"
                src={money}
                alt="..."
                style={{ maxHeight: "200px", objectFit: "contain" }}
            draggable="false"

              />
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Affordable Education</h5>
                <hr />
                <p className="card-text flex-grow-1">
                  We are dedicated to providing affordable education without
                  compromising on quality. At our school, we believe that every
                  child deserves access to excellent learning opportunities,
                  regardless of their financial background.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cards;
